
import {Component, Vue} from 'vue-property-decorator';
import {ElForm} from "element-ui/types/form";
import {createInvoice} from "@/api/invoice/index";
import EditInvoice, {CreateInvoiceReq} from "@/views/invoice/component/EditInvoice.vue";
import {Message} from "element-ui";

@Component({
  name: 'UploadInvoice',
  components: {EditInvoice}
})
export default class UploadInvoice extends Vue {
  private showDialog = false;
  private options = [
    {
      value: 'TUI_SHUI',
      label: '退税发票'
    },
    {
      value: 'SHOU_GONG',
      label: '手工发票'
    },
    {
      value: 'NEI_XIAO',
      label: '内销发票'
    }
  ];
  private form = {
    type: '',
    fileList: []
  }

  private fileList = []
  private rules = {
    type: [
      {required: true, message: '请选择发票类型', trigger: 'blur'}
    ],
    fileList: [
      {required: true, message: '请选择发票', trigger: 'blur'},
      {
        validator: (rule, value, callback) => {
          if (value?.length === 0) {
            callback(new Error('请选择文件'));
          } else {
            callback();
          }
        }
      }
    ]
  }

  private noticeText =
      `*注意事项：
          1. 需要同时上传发票的.PDF和.XML文件，XML文件用作解析，PDF作为源文件上传保存
          2. 发票的文件名保持从税务局下载时的样子，不要修改文件名`;

  public handleHttpRequest(obj) {
    const file = obj.file;
    this.form.fileList.push(file);
  }

  public handleRemove(file, fileList) {
    this.form.fileList = this.form.fileList.filter((item) => item.uid !== file.uid);
  }

  private confirmLoading = false;

  public async handleSubmit() {
    console.log(this.form);
    if (this.clickUploadExcFile && this.req == null) {
      Message.error({
        message: '请编辑发票内容',
        duration: 2000
      })
      return;
    }
    let formData = new FormData();
    formData.append("type", this.form.type);
    formData.append("reqParam", JSON.stringify(this.req));
    // 遍历 fileList 并逐个添加文件到 formData
    for (const file of this.form.fileList) {
      formData.append("files", file);
    }
    this.confirmLoading = true;
    (this.$refs['formRef'] as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
        await createInvoice(formData);
        this.$message.success('上传成功');
        this.showDialog = false;
        this.confirm();
        this.clearEditDialog();
        }catch (e){
          console.error(e)
        }
      } else {
        console.log('error submit!!')
      }
      this.confirmLoading = false;
    });
  }
  private clickUploadExcFile = false;
  public openDialog(clickUploadExcFile:boolean) {
    this.showDialog = true;
    this.clickUploadExcFile = clickUploadExcFile;
    this.resetForm();
  }

  public resetForm() {
    this.fileList = []
    this.$nextTick(() => {
      (this.$refs['formRef'] as ElForm).resetFields();
    })
  }
  private req:CreateInvoiceReq = null;

  private editInvoiceSuccess(req:CreateInvoiceReq) {
    this.req = req;
  }

  public confirm(){
     this.$emit("confirm");
  }

  public openEditDialog() {
    (this.$refs['editInvoiceRef'] as EditInvoice)
        .openDialog()
  }

  public clearEditDialog() {
    (this.$refs['editInvoiceRef'] as EditInvoice)
        .clearVariable()
  }

  public cancelUpload() {
    this.clearEditDialog();
    this.showDialog = false;
  }

  private labelPosition = "left";

}
